import { useState } from 'react';
import CommonTabContent from '../../../components/common-tab-content';
const options = ['Translate english to spanish', 'Translate Natural language to SQL Query'];
interface PromptText {
	[key: number]: string;
}
const promptText: PromptText = {
	0: 'Translate the given English text into Spanish. Do not translate names or proper nouns. Output only the translation, with no accompanying message. Provide output in markdown format.',
	1: 'Create a SQL query to return the requested information. Output only the final SQL query, with no accompanying message',
};

const TranslateTabContent: React.FC = () => {
	const [promptValue, setPromptValue] = useState<string>(promptText[0]);

	const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOptionIndex = parseInt(e.target.value);
		setPromptValue(promptText[selectedOptionIndex]);
	};
	return (
		<div className="max-w-2xl">
			<div className="mb-4">
				<select
					className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
					onChange={handleSelectChange}
				>
					{options.map((item, index) => (
						<option key={index} value={index}>
							{item}
						</option>
					))}
				</select>
			</div>
			<CommonTabContent defaultPrompt={promptValue} />
		</div>
	);
};

export default TranslateTabContent;
